<script>
import CustomDictTag from '@/components/DictCustomTag/index.vue'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { tableMixin } from '@/store/table-mixin'
import { userAddressPageUserDetail } from '@/api/biz/userDetail'

export default {
  name: 'UserAddressTable',
  components: { CustomDictTag },
  mixins: [tableMixin],
  props: {
    userId: undefined
  },
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      // 预览封面
      previewImageVisible: false,
      previewUrl: false,
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('用户昵称'),
          dataIndex: 'userNickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('姓名'),
          dataIndex: 'realName',
          align: 'center'
        },
        {
          title: this.$t('电话'),
          dataIndex: 'mobile',
          align: 'center'
        },
        {
          title: this.$t('标签'),
          dataIndex: 'addressLabel',
          align: 'center'
        },
        {
          title: this.$t('性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('邮编'),
          dataIndex: 'postCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('所在地'),
          dataIndex: 'areap',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('省市区'),
          dataIndex: 'areax',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('是否默认'),
          dataIndex: 'isDefault',
          scopedSlots: { customRender: 'isDefault' },
          align: 'center'
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
    userId(newVal) {
      this.getList()
    }
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    getList() {
      if (!this.userId) {
        return
      }
      this.loading = true
      this.queryParam.id = this.userId
      userAddressPageUserDetail(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    }
  }
}
</script>

<template>
  <a-card>
    <a-table
      :loading="loading"
      :size="tableSize"
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :pagination="false"
      :bordered="tableBordered"
      :scroll="{ x: '160%' }"
    >
      <span slot="sex" slot-scope="text, record">
        <custom-dict-tag :options="customDict.SexEnum" :color="true" :value="record.sex" />
      </span>
      <span slot="billType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.UserBalanceTypeEnum" :color="true" :value="record.billType" />
      </span>
      <span slot="billType" slot-scope="text, record">
        <custom-dict-tag :options="customDict.UserBalanceTypeEnum" :color="true" :value="record.billType" />
      </span>
      <span slot="isDefault" slot-scope="text, record">
        {{ record.isDefault ? 'Yes' : 'No' }}
      </span>
      <span slot="createTime" slot-scope="text, record">
        {{ parseTime(record.createTime) }}
      </span>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
  </a-card>
</template>

<style scoped lang="less">

</style>
